import { IconModule } from "./../icon/icon.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HeroComponent } from "./hero.component";
import { CardModule } from "../card/card.module";
import { CaptionModule } from "../caption/caption.module";
import { BreadcrumbModule } from "../breadcrumb/breadcrumb.module";
import { ButtonModule } from "../button/button.module";

@NgModule({
	declarations: [HeroComponent],
	imports: [
		CommonModule,
		CardModule,
		CaptionModule,
		BreadcrumbModule,
		ButtonModule,
		IconModule
	],
	exports: [HeroComponent]
})
export class HeroModule {}
